import { useEffect } from 'react'
import CustomHead from 'components/common/HeadMeta/HeadMeta'
import Template from 'components/downloads/DownloadAbout'

const Download: React.FC = () => {
  useEffect(() => {
    document.querySelector('body').classList.remove('non-chat')
  }, [])
  return (
    <>
      <CustomHead
        keyword={'UI/UX 生成AI クラウドネイティブ DevOps モダンアプリケーション開発'}
        image={'https://aitria.co.jp/images/img/download/about/ogp.png'}
        url={'https://aitria.co.jp/download/about/'}
        title="UI/UX＆モダナイズ開発サービス紹介ガイド | 資料ダウンロード | Aitria（アイトリア）"
        description="Aitria（アイトリア）の会社概要および提供するサービス一覧を紹介しております"
      />
      <Template />
    </>
  )
}

export default Download
